export const EKOMI_STARS_TOKEN = 'sf15335365c4c86ad3dcd';
export const EKOMI_OPINIONS_TOKEN = 'sf15335365b9379200d96';
export const EKOMI_CUSTOMER_ID = '153353';
